import { Text } from '@chakra-ui/react'

const Name = ({name}:{name:string}) => {
  return (
    <Text>{name?.charAt(0).toUpperCase()}{name.slice(1)}</Text>
  )
}

export default Name